export default "__VITE_ASSET__3PXIWtcd__"